<template>
  <div>
    <modal
      :title="$t('header.payment.modal.title')"
      :largeModal="true"
      :heightOfScroll="600"
      v-show="isModalVisible"
      @close="closeModal">
      <template #body>
        <perfect-scrollbar v-if="awardData.length >= 1">
          <base-table
            :itemsCenter="true"
            :head="tableData.head"
            :columnTemplates="tableData.sizeColumn">
            <base-table-row
              v-for="(element, i) of awardData"
              :key="i"
              :columnTemplates="tableData.sizeColumn">
              <base-table-column class="cell-content">
                <div>
                  <span>{{ element.date_month }}</span>
                </div>
              </base-table-column>

              <base-table-column class="cell-content">
                <div>
                  <span>{{ element.segment_title || element.segment }}</span>
                </div>
              </base-table-column>
              <base-table-column class="cell-content">
                <div>
                  <span>{{ element.cnt_successful_lessons }}</span>
                </div>
              </base-table-column>
              <base-table-column class="cell-content">
                <div>
                  <span>{{ element.cnt_payments }}</span>
                </div>
              </base-table-column>
              <base-table-column class="cell-content">
                <div>
                  <span>{{ element.avg_check }}</span>
                </div>
              </base-table-column>
              <base-table-column class="cell-content">
                <div>
                  <span>{{ element.avg_quality }}</span>
                </div>
              </base-table-column>
              <base-table-column class="cell-content">
                <div>
                  <span>{{ element.avg_a2p }}</span>
                </div>
              </base-table-column>
              <base-table-column class="cell-content">
                <div>
                  <span>{{ element.award }}</span>
                </div>
              </base-table-column>
              <base-table-column class="cell-content">
                <div>
                  <span>{{ element.currency }}</span>
                </div>
              </base-table-column>
            </base-table-row>
          </base-table>
        </perfect-scrollbar>
      </template>
    </modal>
  </div>
</template>

<script>
export default {
  data() {
    return {
      isModalVisible: false,
      awardData: [],
      tableData: {
        head: [
          this.$t("header.payment.modal.tableTitles.date"),
          this.$t("header.payment.modal.tableTitles.segment"),
          this.$t("header.payment.modal.tableTitles.completedTc"),
          this.$t("header.payment.modal.tableTitles.completedPayments"),
          this.$t("header.payment.modal.tableTitles.aov"),
          this.$t("header.payment.modal.tableTitles.quality"),
          this.$t("header.payment.modal.tableTitles.a2p"),
          this.$t("header.payment.modal.tableTitles.payment"),
          this.$t("header.payment.modal.tableTitles.currency"),
        ],
        sizeColumn: "repeat(9, 1fr)",
        row: {},
      },
    };
  },
  methods: {
    async openModal() {
      this.awardData = this.$store.state.user.user.mimkAward.data;
      this.isModalVisible = true;
    },
    closeModal() {
      this.$store.commit("globalModals/setSalaryModal", false);
      this.isModalVisible = false;
    },
  },
};
</script>

<style></style>
